import { PartConfiguratorTopLevelView } from "src/components/views/erp/configurator/configuratorForm/PartConfiguratorTopLevelView.tsx";
import { PartConfiguratorTreeResult } from "src/components/views/erp/configurator/configuratorForm/configuratorTree/PartConfiguratorTreeStatefulView.tsx";
import { ConfigurationCreationApi } from "src/api/generated/erp/configurator/api/configurationCreationApi";
import { DataDirtyStateChangeHandler } from "src/utils/dataDirtyStateChangeHandler.ts";
import { CloseDialogFunc } from "src/components/common/dialogs/GenericDialogContext.ts";
import { PartConfigurationBomLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/partConfigurationBomLinePartConfiguratorType.ts";
import { ConfigurationManualEditContext } from "src/api/generated/erp/configurator/manualEdit/configurationManualEditContext.ts";

export interface PartConfigurationBomLineConfiguratorViewProps {
	partConfigurationBomLineId: number;
	closeDialog: CloseDialogFunc;
	refreshSourceView?: () => void;
	disabled?: boolean;
	onDataDirtyStateChanged?: DataDirtyStateChangeHandler;
	manualEditContext?: ConfigurationManualEditContext;
}

export const PartConfigurationBomLineConfiguratorView = ({
	partConfigurationBomLineId,
	closeDialog,
	refreshSourceView,
	disabled,
	onDataDirtyStateChanged,
	manualEditContext,
}: PartConfigurationBomLineConfiguratorViewProps) => {
	const configuratorType: PartConfigurationBomLinePartConfiguratorType = {
		type: "partConfigurationBomLine",
		partConfigurationBomLineId: partConfigurationBomLineId,
	};

	return (
		<PartConfiguratorTopLevelView
			configuratorType={configuratorType}
			readonly={disabled}
			onDataDirtyStateChanged={onDataDirtyStateChanged}
			onCompleted={async (result) => {
				if (result.type === "success") {
					await onSubmit(result.value);
				} else {
					await closeDialog?.({ confirmIfEdited: true });
				}
			}}
		/>
	);

	async function onSubmit({
		propertyValues,
		propertyInputValues,
		configurationSessionId,
	}: PartConfiguratorTreeResult) {
		await ConfigurationCreationApi.createPartConfigurationForBomLine({
			partConfigurationBomLineId: partConfigurationBomLineId,
			propertyValues: propertyValues,
			propertyInputValues: propertyInputValues,
			configurationSessionId: configurationSessionId,
			manualEditContext,
		});

		await closeDialog();
		refreshSourceView?.();
	}
};
